export default "__VITE_ASSET__BDCR2Gaa__"